import { isCardCode } from "@/features/card/lib/card-code";

const LAST_CARD_KEY = "play-card.last-code";

export function rememberCardCode(code: string): void {
	if (!isCardCode(code) || typeof sessionStorage === "undefined") {
		return;
	}
	sessionStorage.setItem(LAST_CARD_KEY, code);
}

export function lastCardPath(): string | null {
	if (typeof sessionStorage === "undefined") {
		return null;
	}
	const code = sessionStorage.getItem(LAST_CARD_KEY);
	return isCardCode(code ?? undefined) ? `/${code}` : null;
}
